<template>
        <div class="contact-panel">
                <div class="block tel" @click="telCallback">
                    <i class="tel-icon fl"></i>
                    <p class="fl text" v-html="telText">{{telText}}</p>
                </div>
                <div class="block qq">
                    <template v-if="qqLink">
                        <a :href="'https://jq.qq.com/?'+qqLink">
                            <i class="qq-icon fl"></i>
                            <p class="fl text" v-html="qqText">{{qqText}}</p>
                        </a>
                    </template>
                    <template v-else>
                        <a>
                            <i class="qq-icon fl"></i>
                            <p class="fl text" v-html="qqText">{{qqText}}</p>
                        </a>
                    </template>    
                </div>
                <slot name="extend"></slot>
                <a class="block top" @click="scrollToTop"><i></i></a>
        </div>
</template>
<script>
    export default {
        name: 'ipContactPanel',
        props:{
            telText:{
                type:String,
                default: "服务热线82000860-8154"
            },
            qqLink:{
                type:String,
                default: "",
                required:true
            },
            qqText:{
                type:String,
                default: "QQ在线客服"
            }
        },
        methods: {
            scrollToTop (){
                if(window){
                    let currentScroll = document.documentElement.scrollTop || document.body.scrollTop;
                    if (currentScroll > 0) {
                        window.scrollTo (0,currentScroll - (currentScroll/5));
                        window.requestAnimationFrame(this.scrollToTop);
                    }

                }
            },
            telCallback () {
                this.$emit('telCallback');
            }
        }
    }
</script>
<style lang="scss">
    .contact-panel{
        position: fixed;
        top: 50%;
        right: 0;
        width: 43px;
        background: #fff;
        border: 1px solid #f0f0f0;
        z-index: 999;
        transform: translateY(-50%);
        .block{
            padding: 15px 0;
            border-bottom: 1px solid #f0f0f0;
            overflow: hidden;
        }
        .tel {
            .tel-icon {
                padding: 0;
                border: 0;
                font-size: 100%;
                vertical-align: baseline;
                text-decoration: none;
                background-position: -17px 0px !important;
                margin: 9px 0 0 12px;
                display: inline-block;
                width: 16px;
                height: 18px;
                background: url(../../../../public/image/contact-icon.png) no-repeat;
            }
        }
        .qq{
            .qq-icon {
                background-position: 0px 0px;
                margin: 0 0 0 12px;
                display: inline-block;
                width: 16px;
                height: 18px;
                background: url(../../../../public/image/contact-icon.png) no-repeat;
            }

        }
        .top{
            display: block;
            width: 141px;
            margin: 0 auto;
            text-align: center;
            cursor: pointer;
            i {
                display: block;
                width: 16px;
                height: 18px;
                margin: 0 auto;
                background: url(../../../../public/image/contact-icon.png) no-repeat;
                background-position: -50px 0px;
            }
        }
        .text{
            display: none;
            width:100px;
            font-size: 12px;
            color: #666;
            margin: 0 0 0 10px;
            line-height: 18px;
        }
        .fl {
            float: left;
        }
        &:hover{
            width: 143px;
            .text{
                display: inline-block;
            }
        }
    }
</style>